import React from "react";
import { useOtotransBankAccountViewModel } from "./BankAccountViewModel";
import LayoutComponent from "presentation/layout/Layout";
import { Container, Box, Grid, Stack, Typography, Button } from "@mui/material";
import DataTable from "presentation/components/DataTable";

const OtotransBankAccountComponent = () => {
    const {
        t,
        data,
        modal,
        modalHandler,
        columns,
        submitFilterProduct,
        page,
        setPage,
        pageSize,
        setPageSize,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
    } = useOtotransBankAccountViewModel();
    return (
        <LayoutComponent>
      <Container
        maxWidth={false}
        sx={{ height: "100vh", backgroundColor: { xs: "#fff", md: "#f4f4f4" } }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            paddingTop: "2rem",
          }}
        >
          <Box
            sx={{
              width: "95%",
              backgroundColor: "white",
              boxShadow: "0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
              borderRadius: "8px",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "rgba(34, 136, 102, 0.12)",
              },
            }}
          >
            <Grid
              container
              sx={{
                boxShadow: { sm: "0 0 5px #ddd" },
                padding: "1rem",
              }}
            >
              <Stack
                direction="row"
                className="headerSetorku"
                sx={{
                  width: "100%",
                  justifyContent: "space-between",
                  '@media (max-width: 600px)': {
                    flexDirection: 'column',
                    alignItems: 'center',
                    '& .headerName': {
                      textAlign: 'center',
                      marginBottom: '1rem'
                    },
                    '& .headerButton': {
                      alignItems: 'center',
                      mb: '1rem',
                      width: '100%',
                      '& button': {
                        width: '100%'
                      }
                    }
                  }
                }}
              >
                <Typography
                  className="headerName"
                  variant="h6"
                  component="h1"
                  sx={{
                    mb: "1.5rem",
                    fontWeight: 600,
                  }}
                >
                  {t("setorku.product.header")}
                </Typography>

                <Stack spacing={2} direction="row" className="headerButton">
                  <Button
                    variant="outlined"
                    sx={{
                      height: "42px",
                      color: "rgba(34, 136, 102, 0.5)",
                      borderColor: "rgba(34, 136, 102, 0.5) !important",
                    }}
                    onClick={() => modalHandler("filter")}
                  >
                    {t("setorku.product.filter_button")}
                  </Button>
                  <Button
                    onClick={() => modalHandler("add")}
                    variant="contained"
                    sx={{
                      height: "42px",
                      borderColor: "rgba(34, 136, 102, 0.5)",
                      color: "#FFFFFF",
                      backgroundColor: "rgba(40, 99, 83, 1) !important",
                      shadows: "rgba(0, 0, 0, 0.12)",
                    }}
                  >
                    {t("setorku.product.add_button")}
                  </Button>
                </Stack>
              </Stack>
              {data.partner.loading ? (
                <h1>Loading ...</h1>
              ) : (
                <DataTable
                  {...{
                    data: [],
                    totalRows: 0,
                    columns,
                    setPage,
                    setPageSize,
                    page,
                    pageSize,
                  }}
                />
              )}
            </Grid>
          </Box>
        </div>

        {/* <AddModal applyButton={submitAddProduct} onClose={() => modalHandler('add')} open={modal.add} />
        <FilterModal applyButton={submitFilterProduct} onClose={() => modalHandler('filter')} open={modal.filter} dateData={{
          startDate,
          endDate,
          setStartDate,
          setEndDate
        }} />
        <EditModal applyButton={submitEditProduct} onClose={() => modalHandler('edit')} open={modal.edit} data={modal.data} />
        <ConfirmationModalComponent type="delete" open={modal.delete} onClose={() => modalHandler('delete')} action={submitDeleteProduct} /> */}
      </Container>
    </LayoutComponent>
    );
};

export default OtotransBankAccountComponent;